export const success_colors = (dark) => ({
    '50': '#E9FBF0',
    '100': '#C6F6D9',
    '200': '#9AEFBC',
    '300': '#6AE79C',
    '400': '#3EE07F',
    '500': '#21CC66',
    '600': '#1DB45A',
    '700': '#1AA251',
    '800': '#178D46',
    '900': '#0F5C2E',
    main: dark ? '#66bb6a' : '#1AA251',
    light: dark ? '#81c784' : '#6AE79C',
    dark: dark ? '#388e3c' : '#0F5C2E',
    contrastText: dark ? 'rgba(0, 0, 0, 0.87)' : '#fff',
});
